export default __webpack_public_path__ + "static/media/Doc2.0328ae5a.jpg";